import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   // max-width: 520px;
   width: 100%;
   height: 422px;
   overflow: auto;
   padding-right: 15px;

   .action {
      margin-bottom: 12px;
   }

   .topicSelect {
      margin-bottom: 12px;
   }

   .sectionCard {
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background: #fff;
      overflow: hidden;
   }

   .sectionToggle {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: none;
      background: #f8fafc;
      color: #111827;
      padding: 10px 12px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      text-align: left;
   }

   .sectionToggleIcon {
      font-size: 16px;
      line-height: 1;
      color: #6b7280;
      margin-left: 8px;
   }

   .topicChecklist {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px 12px;
      padding: 10px;
      background: #fafafa;
   }

   .topicItem {
      display: flex;
      align-items: center;
      gap: 7px;
      font-size: 13px;
      color: #374151;
      cursor: pointer;
      user-select: none;
      line-height: 1.35;
   }

   .topicItem input {
      width: 14px;
      height: 14px;
      accent-color: #95bf47;
      cursor: pointer;
      margin: 0;
      flex-shrink: 0;
   }

   .toolbar {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      flex-wrap: wrap;
   }

   .generateBtn {
      border: none;
      border-radius: 6px;
      padding: 8px 12px;
      background: #95bf47;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
   }

   .generateBtn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
   }

   .syncState {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      color: #475569;
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 999px;
      padding: 5px 9px;
      line-height: 1;
   }

   .syncState.synced {
      color: #166534;
      border-color: #86efac;
      background: #f0fdf4;
   }

   .syncState.error {
      color: #991b1b;
      border-color: #fca5a5;
      background: #fef2f2;
   }

   .syncState.pending,
   .syncState.syncing {
      color: #92400e;
      border-color: #fcd34d;
      background: #fffbeb;
   }

   .syncDot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      display: inline-block;
      background: currentColor;
      flex-shrink: 0;
   }

   .syncSpinner {
      width: 10px;
      height: 10px;
      border: 2px solid currentColor;
      border-right-color: transparent;
      border-radius: 50%;
      display: inline-block;
      animation: topicSyncSpin 0.8s linear infinite;
      flex-shrink: 0;
   }

   @keyframes topicSyncSpin {
      from {
         transform: rotate(0deg);
      }
      to {
         transform: rotate(360deg);
      }
   }

   .webhook-section {
      margin-bottom: 12px;
   }

   .webhook-section h4 {
      margin: 0 0 6px 0;
      color: #333;
      font-size: 16px;
      font-weight: 600;
   }

   .webhookPanelBody {
      padding: 10px;
      background: #f8fafc;
      display: flex;
      flex-direction: column;
      gap: 10px;
   }

   .webhookGroup {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      background: #ffffff;
      padding: 10px;
   }

   .groupTitle {
      font-size: 12px;
      font-weight: 700;
      color: #334155;
      letter-spacing: 0.02em;
      margin-bottom: 8px;
      text-transform: uppercase;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 13px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      min-width: 0;
      flex: 1;
   }

   .secret-hint {
      color: #4b5563;
      font-size: 12px;
      margin-bottom: 6px;
      line-height: 1.4;
   }

   .secret-input {
      width: 100%;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 13px;
      margin-bottom: 8px;
      outline: none;
      box-sizing: border-box;
   }

   .secret-input:focus {
      border-color: #95bf47;
      box-shadow: 0 0 0 1px #95bf47;
   }

   .warning {
      color: #d97706;
      font-size: 13px;
      margin-bottom: 8px;
   }

   .collapsedValue {
      padding: 10px 12px;
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      background: #ffffff;
   }

   .statusBadge {
      border-radius: 999px;
      font-size: 11px;
      font-weight: 700;
      padding: 5px 9px;
      line-height: 1;
      letter-spacing: 0.02em;
   }

   .statusBadge.ready {
      background: #dcfce7;
      color: #166534;
      border: 1px solid #86efac;
   }

   .statusBadge.missing {
      background: #fff7ed;
      color: #9a3412;
      border: 1px solid #fdba74;
   }

   .error {
      color: #dc2626;
      font-size: 13px;
      margin-bottom: 8px;
   }

   .success {
      color: #166534;
      font-size: 13px;
      margin-bottom: 8px;
   }

   .syncMeta {
      color: #64748b;
      font-size: 12px;
      margin: -4px 0 8px;
   }

   .instructions-section {
      margin: 12px 0 0;
   }

   .instructions-section h5 {
      margin: 0 0 8px 0;
      color: #333;
      font-size: 14px;
      font-weight: 600;
   }

   .steps-list {
      margin: 0;
      padding-left: 18px;
      font-size: 14px;
      line-height: 1.4;
   }

   .steps-list li:not(:last-of-type) {
      margin-bottom: 6px;
   }

   .test-event {
      margin-top: 12px;
      margin-bottom: 12px;
   }

   .testHeader {
      background: #f8fafc;
      border-bottom: 1px solid #e5e7eb;
      padding: 10px 12px;
      font-size: 13px;
      font-weight: 700;
      color: #0f172a;
   }

   .testBody {
      padding: 10px 12px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      gap: 8px;
   }

   .testLabel {
      font-size: 12px;
      color: #334155;
      font-weight: 600;
   }

   .testSelect,
   .testPayload {
      width: 100%;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      font-size: 13px;
      box-sizing: border-box;
      outline: none;
   }

   .testSelect {
      height: 34px;
      padding: 0 10px;
      background: #fff;
   }

   .testPayload {
      min-height: 132px;
      padding: 8px 10px;
      resize: vertical;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      line-height: 1.4;
   }

   .testSelect:focus,
   .testPayload:focus {
      border-color: #95bf47;
      box-shadow: 0 0 0 1px #95bf47;
   }

   .testBtn {
      border: none;
      border-radius: 6px;
      padding: 8px 12px;
      background: #0f766e;
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      width: fit-content;
   }

   .testBtn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
   }

   .testFeedback {
      margin: 0;
      white-space: pre-wrap;
      word-break: break-word;
   }
`;

export const Loader = styled.span`
   width: 68px;
   height: 68px;
   border: 5px solid #9ca3af;
   border-bottom-color: #262627;
   border-radius: 50%;
   display: block;
   box-sizing: border-box;
   animation: rotation 1s linear infinite;
   margin: 0 auto;

   @keyframes rotation {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
`;
